import styled from "styled-components";

export const PageTitle = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  span {
    font-family: Asap;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    color: #c4c4c4;
    text-transform: uppercase;
  }
  svg,
  img {
    width: 25px;
    height: 25px;
    margin-right: 9px;
  }
  line,
  rect,
  path {
    stroke: #c4c4c4;
  }
`;

export const TableActions = styled.div`
  display: flex;
  align-items: center;

  .quickAction {
    font-size: 18px;
    color: #8a50a5;
    cursor: pointer;
    margin-right: 10px;
  }

  .quickAction:hover {
    color: #591f74;
  }
`;
